import styled from "styled-components"

export const StyledMyOfferSpiral = styled.div`
  width: 217px;
  height: 386px;
  position: absolute;
  right: 0;
  top: -240px;
  @media only screen and (max-width: 767px) {
    display: none;
  }
  img {
    width: 100%;
    height: 100%;
  }
`
